import script from "./riskReminderDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./riskReminderDialog.vue?vue&type=script&setup=true&lang=js"

import "./riskReminderDialog.vue?vue&type=style&index=0&id=57684ae1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.31_vue@3.4.31_typescript@5.6.2__webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57684ae1"]])

export default __exports__